<template>
    <div class="modal fade" id="div-fido-authenticate-unsupported" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">この環境ではパスキーをご利用いただけません。</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center pt-0">
                    <img src="@/assets/img/warning.png" width="66px"/>
                    <div class="w-100">
                        <span class="fs-14px">
                            現在お使いの端末／ブラウザはパスキーに対応していないため、パスキーをご利用いただけません。
                        </span>
                    </div>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-6 w-100">
                            <button type="button" class="btn btn-sm btn-primary w-100" @click="close()">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";

    export default {
        name: "FidoAuthenticateUnsupported",
        data() {
            return {
                params: {}
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_FIDO_AUTHENTICATE_UNSUPPORTED, () => {
                    $('#div-fido-authenticate-unsupported').modal({backdrop: 'static', keyboard: false});
                    $("#div-fido-authenticate-unsupported").modal("show");
                });
            },
            close() {
                $("#div-fido-authenticate-unsupported").modal("hide");
            },
        }
    }
</script>

<style scoped>
    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }
</style>
